import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AutosaveService } from '../autosave.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subscription, of } from 'rxjs';
import { Location } from '@angular/common';
import { CurrencySelectAmountOption } from '@brightside/brightside-ui';

@Component({
    selector: 'brightside-web-autosave-simple-selector',
    templateUrl: './autosave-simple-selector.component.html',
    styleUrls: ['./autosave-simple-selector.component.scss'],
    providers: [AutosaveService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AutosaveSimpleSelectorComponent implements OnInit {
  sub = new Subscription();

  options$ = this.autoSaveSvc.currentSelectionOption;
  processing$ = this.autoSaveSvc.processing;

  simpleSelectorVal$: BehaviorSubject<number> = new BehaviorSubject<number>(50);

  autoSaveTitle: string;
  autoSaveDescription: string; 
  recommendedValue: number = 50; 
  options: [];
  chooseOwnRoute: [];

  private _defaultOptions: CurrencySelectAmountOption[];

  constructor(
    private autoSaveSvc: AutosaveService,
    private _route: ActivatedRoute,
    private router: Router,    
    private _location: Location
  ) {
    if (this._route.snapshot.data['routeOnSuccess']) {
      this.autoSaveSvc.routeOnSuccess = this._route.snapshot.data['routeOnSuccess'];
    }
    if (this._route.snapshot.data['routeOnBack']) {
      this.autoSaveSvc.routeOnBack = this._route.snapshot.data['routeOnBack'];
    }

    this.autoSaveTitle = this._route.snapshot.data.title || 'AUTOSAVE_SELECT_TITLE';
    this.autoSaveDescription = this._route.snapshot.data.description || 'AUTOSAVE_SELECT_DESC';

    if(this._route.snapshot.data.options && this._route.snapshot.data.options.length) {
      this.options = this._route.snapshot.data.options;
      this._defaultOptions = this.options.map(o => ({
        value: o,
        selected: false
      }))
      this.options$ = of(this._defaultOptions);
    }

    if (this._route.snapshot.data.recommendedValue) {
      this.recommendedValue = this._route.snapshot.data.recommendedValue
      this.simpleSelectorVal$.next(this.recommendedValue);
    }

    this.chooseOwnRoute = this._route.snapshot.data.chooseOwnRoute;
  }

  ngOnInit(): void {
    this.autoSaveSvc.getAutoSavingsInfo(true);
  }

  onSubmit() {
    this.sub.add(
      this.simpleSelectorVal$.subscribe((value) => {
        this.autoSaveSvc.setAutoSaveAmount(value);        
        this.autoSaveSvc.createAutoSaveSchedule();
      })
    );
  }

  chooseOwn() {    
    if (this.chooseOwnRoute) {
      this.router.navigate(this.chooseOwnRoute);
    } else {
      this.router.navigate(['accounts', 'loans', 'creation', 'autosave']);
    }    
  }

  routeUserOnBack() {    
    if (this.autoSaveSvc.routeOnBack) {
      this.router.navigate(this.autoSaveSvc.routeOnBack);
    } else {
      this._location.back();
    }
  }

  autosaveAmount(amount: number) {
    this.simpleSelectorVal$.next(amount);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
